import itemsTypes from "@store/constants/itemsTypes";

const INITIAL_STATE = {
  items: [],
  adminItems: [],
  isLoading: true,
};

const itemsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case itemsTypes.FETCH_ITEMS:
      return {
        ...state,
        items: action.items,
        isLoading: false,
      };
    case itemsTypes.RESET_ITEMS:
      return {
        ...state,
        items: [],
        isLoading: false,
      };
    case itemsTypes.FETCH_ADMIN_ITEMS:
      return {
        ...state,
        adminItems: action.items,
        isLoading: false,
      };
    case itemsTypes.RESET_ADMIN_ITEMS:
      return {
        ...state,
        adminItems: [],
        isLoading: false,
      };
    default:
      return state;
  }
};

export default itemsReducer;
